import { CommonModule } from '@angular/common';
import { Component, inject, input } from '@angular/core';
import { ButtonComponent } from '../../primitives/button/button.component';
import { AuthService } from 'src/app/services/auth.service';

@Component({
    selector: 'app-login-placeholder',
    templateUrl: './login-placeholder.component.html',
    styleUrls: ['./login-placeholder.component.scss'],
    imports: [CommonModule, ButtonComponent]
})
export class LoginPlaceholderComponent {
  private $auth = inject(AuthService);

  public title = input.required<string>();
  public description = input.required<string>();

  logIn() {
    this.$auth.showLogin();
  }
}